module.exports = require("npm:async.util.once@0.5.2/index.js");